import {Component, OnInit} from '@angular/core';
import {
  InteractionCardDto,
  InteractionCardsBackgroundOverlayEnum,
  InteractionCardsBackgroundPositionEnum,
  InteractionCardsBackgroundSizeEnum,
  InteractionCardsRatingTypeEnum,
  InteractionsCardsTypeEnum
} from '../models/card.model';

@Component({
  selector: 'app-test',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.scss'],
})
export class TestComponent implements OnInit {

  constructor() {
  }

  card: InteractionCardDto = {
    id: '1',
    // type: InteractionsCardsTypeEnum.quiz,
    type: null,
    isTitle: true,
    isText: true,
    isRequired: true,
    isMultiselect: false,
    isRolePlay: false, // TODO
    isNoCorrect: false, // TODO
    title: '',
    text: '',
    legend1: '',
    legend2: '',
    text1: '',
    text2: '',
    comment: 'Comment',
    url1: 'url1',
    url2: 'url2',
    minSelect: 1,
    maxSelect: 1,
    ratingType: InteractionCardsRatingTypeEnum.buttons,
    score: 0,
    color: '#ffffff',
    titleColor: '#ffffff',
    backgroundColor: '#40348A',
    backgroundImage: '',
    backgroundPosition: InteractionCardsBackgroundPositionEnum.fullscreen,
    backgroundSize: InteractionCardsBackgroundSizeEnum.auto,
    backgroundOverlay: InteractionCardsBackgroundOverlayEnum.none,
    cardAnswer: null,
    interactionsCardCategories: [
      {
        id: '1',
        interactionsCardId: '1',
        text: 'Category 1',
        title: 'Category 1',
        isText: true,
        order: 1,
      },
      {
        id: '2',
        interactionsCardId: '1',
        text: 'Category 2',
        title: 'Category 2',
        isText: true,
        order: 2,
      },
    ],
    interactionsCardItems: [
      {
        id: '1',
        isValid: true,
        score: 0,
        text: 'Question 1',
        textAnswer: 'Answer 1',
        order: 3,
        correctOrder: 0,
        comment: 'Comment',
        interactionCardCategoryId: '1',
        cardItemAnswer: null,
      },
      {
        id: '2',
        isValid: true,
        score: 0,
        text: 'Question 2',
        textAnswer: 'Answer 2',
        order: 2,
        correctOrder: 1,
        comment: 'Comment',
        interactionCardCategoryId: '2',
        cardItemAnswer: null,
      },
      {
        id: '3',
        isValid: true,
        score: 0,
        text: 'Question 3',
        textAnswer: 'Answer 3',
        order: 1,
        correctOrder: 2,
        comment: 'Comment',
        interactionCardCategoryId: '1',
        cardItemAnswer: null,
      },
      {
        id: '4',
        isValid: true,
        score: 0,
        text: 'Question 4',
        textAnswer: 'Answer 4',
        order: 0,
        correctOrder: 3,
        comment: 'Comment',
        interactionCardCategoryId: '2',
        cardItemAnswer: null,
      },
    ]
  };

  phrases = [
    {"phrase": "engaging content", "frequency": 1, "importance": 0.95},
    {"phrase": "short attention spans", "frequency": 1, "importance": 0.90},
    {"phrase": "easier to digest", "frequency": 2, "importance": 0.92},
    {"phrase": "own pace", "frequency": 1, "importance": 0.88},
    {"phrase": "busy schedules", "frequency": 1, "importance": 0.87},
    {"phrase": "flexible", "frequency": 1, "importance": 0.85},
    {"phrase": "short, snappy", "frequency": 1, "importance": 0.89},
    {"phrase": "quick retention", "frequency": 1, "importance": 0.88},
    {"phrase": "digestible bits", "frequency": 1, "importance": 0.86},
    {"phrase": "accessible", "frequency": 2, "importance": 0.90},
    {"phrase": "just in time learning", "frequency": 1, "importance": 0.93},
    {"phrase": "traditional methods", "frequency": 1, "importance": 0.85},
    {"phrase": "longer form learning", "frequency": 1, "importance": 0.87},
    {"phrase": "short term attention", "frequency": 1, "importance": 0.88},
    {"phrase": "engagement", "frequency": 1, "importance": 0.89},
    {"phrase": "effective application", "frequency": 1, "importance": 0.90},
    {"phrase": "single specific point", "frequency": 1, "importance": 0.88},
    {"phrase": "specific topics", "frequency": 1, "importance": 0.87},
    {"phrase": "more diverse learning needs", "frequency": 1, "importance": 0.86},
    {"phrase": "fit it into their schedule", "frequency": 1, "importance": 0.89}
  ]


  ngOnInit() {
  }

}
